import React, { useState } from 'react'
import { changeFormatdate } from '../../../../utils/formatDate'
import { Col, Row, Table, Tooltip } from 'antd'
import { ShareAltOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import useHome from '../../context/useHome'
import { useNavigate } from 'react-router-dom'
import SharedModal from '../../../../components/sharedModal'

const AnnounceTable = () => {
    const { homeData } = useHome()
    const history = useNavigate()
    const [openModal, setOpenModal] = useState(false)
    const [dataModal, setDataModal] = useState(null)

    const handleShare = (data) => {
        console.log('handleShare', data)
        setDataModal(data)
        setOpenModal(true)
    }

    const handleCancelModal = () => {
        setOpenModal(false)
    }

    const isMobile = window.innerWidth <= 768;

    const columns = [
        {
            title: 'ตำแหน่งงาน',
            dataIndex: 'positionCareerName',
            width: '200px',
            key: 'positionCareerName',
            render: (item, record, index) => {
                // console.log('record 36',record)
                return (
                    <Tooltip
                        trigger={isMobile ? 'click' : 'hover'}
                        placement="topLeft"
                        title={(record.positionManageName ?? '') + ' ' + (record.positionCareerName ?? '') + ' ' + (record.empLevel ?? '') + ' ' + (record.wardName ?? '') + ' ' + (record.divisionName ?? '') + ' ' + (record.departmentName ?? '') + ' ' + (record.buName ?? '')}>
                        <div className='line-clamp-2'>{(record.positionManageName ?? '') + ' ' + (record.positionCareerName ?? '') + ' ' + (record.empLevel ?? '') + ' ' + (record.wardName ?? '') + ' ' + (record.divisionName ?? '') + ' ' + (record.departmentName ?? '') + ' ' + (record.buName ?? '')}</div>
                    </Tooltip>
                )
            },
        },
        {
            title: 'ประเภทการว่าจ้าง',
            dataIndex: 'employmentTypeName',
            width: '200px',
            key: 'employmentTypeName',
            render: (item, record, index) => (
                <Tooltip trigger={isMobile ? 'click' : 'hover'} placement="topLeft" title={item ?? 'ไม่ระบุ'}>
                    <div className='line-clamp-2'>{item ?? 'ไม่ระบุ'}</div>
                </Tooltip>
            ),
        },
        {
            title: 'หน่วยงาน',
            dataIndex: 'buName',
            width: '200px',
            key: 'buName',
            render: (item, record, index) => (
                <Tooltip trigger={isMobile ? 'click' : 'hover'} placement="topLeft" title={item ?? 'ไม่ระบุ'}>
                    <div className='line-clamp-2'>{item ?? 'ไม่ระบุ'}</div>
                </Tooltip>
            ),
        },
        // {
        //     title: 'สถานที่ทำงาน',
        //     dataIndex: 'address',
        //     width: '250px',
        //     key: 'address',
        //     render: (item, record, index) => (
        //         <Tooltip trigger={isMobile ? 'click' : 'hover'} placement="topLeft" title={item ?? 'ไม่ระบุ'}>
        //             <div className='line-clamp-2'>{item ?? 'ไม่ระบุ'}</div>
        //         </Tooltip>
        //     ),
        // },
        // {
        //     title: 'จังหวัด',
        //     dataIndex: 'province',
        //     width: '120px',
        //     key: 'province',
        //     render: (item, record, index) => (
        //         <Tooltip trigger={isMobile ? 'click' : 'hover'} placement="topLeft" title={item ?? 'ไม่ระบุ'}>
        //             <div className='line-clamp-2'>{item ?? 'ไม่ระบุ'}</div>
        //         </Tooltip>
        //     ),
        // },
        {
            title: 'ช่วงเวลาที่เปิดรับสมัคร',
            dataIndex: 'date',
            key: 'date',
            width: '200px',
            align: 'center',
            render: (item, record, index) => {
                return (
                    <Row className='range-date flex line-clamp-2'>
                        <Col span={24} className="start-date">
                            {`${changeFormatdate(record.startDate)} - `}
                        </Col>
                        <Col span={24} className="end-date">
                            {record.isNoEndDate === false ? `${changeFormatdate(record.endDate)}` : 'ไม่กำหนด'}
                        </Col>
                    </Row>
                )
            }
        },

    ]

    const shareColumn = {
        title: '',
        dataIndex: 'share',
        key: 'share',
        width: '100px',
        render: (item, record, index) => {
            return <>
                <div className='cursor-pointer share-icon' onClick={() => handleShare(record)}>
                    <ShareAltOutlined className='icon-footer' />
                </div>
            </>
        }
    }

    const CustomPagination = ({ current, pageSize, total, onChange }) => {
        const totalPages = Math.ceil(total / pageSize);
        const [pageInput, setPageInput] = useState(current);

        const handlePageChange = (newPage) => {
            setPageInput(newPage);
            onChange(newPage, pageSize);
        };

        return (
            <div>
                <button disabled={current === 1} onClick={() => handlePageChange(current - 1)}>
                    Previous
                </button>
                <input
                    type="number"
                    min="1"
                    max={totalPages}
                    value={pageInput}
                    onChange={(e) => setPageInput(e.target.value)}
                />
                <button disabled={current === totalPages} onClick={() => handlePageChange(current + 1)}>
                    Next
                </button>
            </div>
        );
    };

    const [pagination, setPagination] = useState({ current: 1, pageSize: 2 });

    const handleTableChange = (pagination, filters, sorter) => {
        setPagination(pagination);
    };

    const onClickRow = (record) => {
        console.log('onClickRow', record)
        history(`/JobDetail/${record.orgUnitName ?? record.id}/${record.id}`)
    }

    columns.map((e, i) => {
        e.onCell = (record, rowIndex) => {
            return {
                onClick: () => { onClickRow(record) }, // click row
            };
        }
    })

    const allColumns = [...columns, shareColumn]

    return (
        <>
            {openModal &&
                <SharedModal
                    data={dataModal}
                    open={openModal}
                    handleCancel={handleCancelModal}
                />
            }

            <Table
                className='cursor-pointer'
                columns={allColumns}
                dataSource={homeData?.jobListJobReqList || []}
                rowKey={'id'}
                size='large'
                scroll={{ x: "max-content" }}
                pagination={{
                    ...pagination,
                    showSizeChanger: false,
                    showQuickJumper: false,
                    // showTotal: (total) => `Total ${total} items`,
                    onChange: handleTableChange,
                    itemRender: (page, type, originalElement) => {
                        if (type === 'prev') {
                            return <FontAwesomeIcon icon={faCaretLeft} />
                        }
                        if (type === 'next') {
                            return <FontAwesomeIcon icon={faCaretRight} />
                        }
                        return originalElement;
                    },
                    locale: { items_per_page: '' },
                    pageSize: 10,
                    total: homeData?.jobListJobReqList?.length || 0,
                    responsive: true,
                    pagination: (props) => <CustomPagination {...props} />,
                }}
            />
        </>
    )
}

export default AnnounceTable